import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import styledNative from "@rentiohq/shared-frontend/dist/components/theme/styled-components.native";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { transparentize } from "polished";
import { Image, Text, View } from "react-native";
import images from "../../../../assets";

export const LisWrap = styledNative(View)`
  margin-top: 24px;
  padding-left: 0px;
  padding-right: 0px;
`;

export const ListItemSelectWrap = styled.div<{ selected?: boolean }>`
  background-color: ${props => {
    if (props.selected === undefined) return "transparent";
    if (props.selected) return transparentize(0.9, props.theme.colors.global5);
    return transparentize(0.5, props.theme.colors.global4);
  }};
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const PaymentMethodIcons = styledNative(View)`
  display: flex;
  flex-direction: row;
  width: fit-content;
  align-items: center;
  gap: 12px;
`;

export const PaymentMethodIconSepa = styledNative(Image).attrs(() => ({
  source: images.ICO_SEPA,
}))`
  width: 36px;
  height: 11px;
`;

export const PaymentMethodIconBcmc = styledNative(Image).attrs(() => ({
  source: images.ICO_BCMC,
}))`
  width: 23px;
  height: 16px;
`;

export const PaymentMethodIconIdealWero = styledNative(Image).attrs(() => ({
  source: images.ICO_IDEAL_WERO,
}))`
  width: 52px;
  height: 20px;
`;

export const PaymentMethodIconPayconiq = styledNative(Image).attrs(() => ({
  source: images.ICO_PAYCONIQ,
}))`
  width: 22px;
  height: 22px;
`;

export const PaymentMethodIconIbanisation = styledNative(Image).attrs(() => ({
  source: images.ICO_IBANISATION,
}))`
  width: 22px;
  height: 16px;
`;

export const ButtonDisabledInfo = styledNative(Text)`
  max-width: 500px;
  align-self: center;
  text-align: center;
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 12px;
  color: ${props => props.theme.colors.global2};
`;

export const ButtonPrimaryWrap = styled.div`
  margin-left: 16px;
  margin-right: 16px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    margin-left: 40px;
    margin-right: 40px;
  }
`;
